import React, { useContext } from 'react';
import { AuthContext } from '../auth/AuthProvider';
import '../../styles/App.css';
import aboutSvg from '../../styles/icons/nav-words/about.svg';
import friendsSvg from '../../styles/icons/nav-words/friends.svg';
import projectsSvg from '../../styles/icons/nav-words/projects.svg';
import gallerySvg from '../../styles/icons/nav-words/gallery.svg';
import logoutSvg from '../../styles/icons/nav-words/logout.svg';
import placesSvg from '../../styles/icons/nav-words/places.svg';


const BarNav = () => {
    const { isAuthenticated, logout } = useContext(AuthContext);  // Access the AuthContext

    return (
        <div className="navbar navbar-expand">
            <div className="nav-group">
                <a href="/"><h3>Kishan</h3></a>
            </div>
            <div className="nav-group">
                <a href="/about" className="nav-item">
                    <img className="nav-word" src={aboutSvg} alt="About" />
                </a>
                {/* <a href="/projects" className="nav-item">
                    <img className="nav-word" src={projectsSvg} alt="Projects" />
                </a> */}
                <a href="/gallery" className="nav-item">
                    <img className="nav-word" src={gallerySvg} alt="Gallery" />
                </a>
                <a href="/places" className="nav-item">
                    <img className="nav-word" src={placesSvg} alt="Places" />
                </a>
                {isAuthenticated ? 
                    <button className="nav-item button" onClick={logout}>
                        <img className="nav-word" src={logoutSvg} alt="Logout" />
                    </button> :
                    <a href="/login" className="nav-item">
                        <img className="nav-word" src={friendsSvg} alt="Friends" />    
                    </a>}
            </div>
        </div>
    )
}

export default BarNav
